import { create } from 'zustand';
import { buildDemoCurrentUser } from '../demo/demoDataset';
import { isDemoModeEnabled } from '../demo/demoRuntime';

const initialDemoUser = isDemoModeEnabled() ? buildDemoCurrentUser() : null;

export const useAuthStore = create((set) => ({
  user: initialDemoUser,
  loading: !isDemoModeEnabled(),
  error: null,

  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  logout: () => set({ user: null, loading: false }),
}));
